import { DeleteDealAssociation, DeleteDealAssociationVariables } from './__generated__/DeleteDealAssociation'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeleteDealAssociation($input: DealAssociationInputV2!) {
    deleteDealAssociation: deleteDealAssociationV2(input: $input) {
      ... on DealAssociationV2 {
        id
        emailAddress
        dealId
      }
      ... on DealAssociationErrorV2 {
        type
        error
      }
    }
  }
`

export const useDeleteDealAssociation = () =>
  useMutation<DeleteDealAssociation, DeleteDealAssociationVariables>(MUTATION)
